<kendo-grid [data]="taskView.gridData" [loading]="taskView.loading" [navigable]="true"
    [pageable]="taskCount > taskView.state.take ? { buttonCount: 5, pageSizes: pageSizes } : false"
    [pageSize]="taskView.state.take" [skip]="taskView.state.skip" [sortable]="true" [sort]="taskView.state.sort"
    [selectable]="{ mode: 'single' }" [resizable]="true" (dataStateChange)="taskDataStateChange($event)"
    [kendoGridSelectBy]="" class="mt-2 w-100" [ngClass]="{'mb-3': allowAddTask, 'mb-2': !allowAddTask}">
    <kendo-grid-messages noRecords="{{ 'NO-TASKS' | translate }}">
    </kendo-grid-messages>
    <kendo-grid-column field="name" title="{{ 'TASK' | translate }}" [width]="90" class="emphasizedLabel ellipsis-text">
        <ng-template kendoGridCellTemplate let-dataItem>
            <a class="pointer" (click)="openTask(dataItem)"
                title="{{dataItem.name}} {{dataItem.description ? '|' : ''}} {{dataItem.description | stripHtml}}">
                <strong [ngClass]="{'completed-task': dataItem.status === 'Completed'}">{{ dataItem.name }}</strong>
            </a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="assigneeName" title="{{'ASSIGNED-TO' | translate}}" [width]="60">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div *ngxPermissionsOnly="['ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD']">
                {{dataItem.assigneeName}}
                <a *ngIf="dataItem.status === 'Open'" class="pointer float-right" title="{{'REASSIGN' | translate}}"
                    (click)="openTaskAssigneeDialog(dataItem)">
                    <i class="fas fa-undo icon-info"></i>
                </a>
            </div>
            <div *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR']">
                {{dataItem.assigneeName}}
            </div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="openedOn" title="{{ 'OPENED-ON' | translate }}" [width]="60" filter="date" format="{0:d}">
        <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{intl.formatDate(intl.parseDate(dataItem.openedOn), "g")}}</span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="dueDate" title="{{ 'DUE-DATE' | translate }}" [width]="50" filter="date" format="{0:d}">
        <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{intl.formatDate(intl.parseDate(dataItem.dueDate), "d")}}</span>
            <a *ngIf="dataItem.status === 'Open'" class="pointer float-right" title="{{'EDIT' | translate}}"
                (click)="openTaskDueDateDialog(dataItem);">
                <i class="fas fa-undo icon-info"></i>
            </a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column class="text-center" field="eventType" [width]="40" title="{{'EVENT-TYPE'|translate}}"
        [columnMenu]="false" [filterable]="false" [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
            <i title="{{dataItem.eventTypeText}} - {{dataItem.event}}" *ngIf="dataItem.eventType"
                [className]="dataItem.eventTypeIcon"></i>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="priority" title="{{ 'PRIORITY' | translate }}" [width]="40"
        [style]="{'text-align': 'center'}">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div [className]="dataItem.priorityBadgeClass"
                [ngClass]="{'extra-priority-padding': dataItem.status !== 'Open'}">{{
                dataItem.priority.charAt(0) }}</div>
            <div class="change-icon">
                <a *ngIf="dataItem.status === 'Open'" class="pointer float-right" title="{{'EDIT' | translate}}"
                    (click)="openTaskPriorityDialog(dataItem);">
                    <i class="fas fa-undo icon-info"></i>
                </a>
            </div>
        </ng-template>
    </kendo-grid-column>
</kendo-grid>
<button
    *ngIf="allowAddTask && caseModel !== undefined && caseModel.channelId !== null && caseModel.channelId !== undefined"
    kendoButton [primary]="true" (click)="createTask()" type="button" class="mb-2 mr-1 float-right">
    {{ 'ADD-TASK' | translate }}<i class="far fa-plus"></i>
</button>

<!-- duedate task dialog -->
<app-task-duedate [task]="task" [dialogOpened]="taskDueDateOpened" (closing)="closeTaskDueDateDialog()"
    (save)="updateTaskDueDate($event)">
</app-task-duedate>

<!-- task assignment dialog -->
<app-task-assign [task]="task" [dialogOpened]="assigneeDialogOpened" (closing)="closeTaskAssigneeDialog();"
    (save)="updateTaskAssignee($event)">
</app-task-assign>

<!-- priority task dialog -->
<app-task-priority [task]="task" [dialogOpened]="priorityDialogOpened" (closing)="closeTaskPriorityDialog();"
    (save)="updateTaskPriority($event)">
</app-task-priority>

<!--add task dialog-->
<app-task-add *ngIf="caseModel !== undefined && caseModel.channelId !== null && caseModel.channelId !== undefined"
    [dialogOpened]="isNewTask" [channelId]="caseModel.channelId" [caseId]="caseModel.id"
    [assigneeId]="createTaskAssigneeId" [allowAssigneeOverride]="true" (cancelling)="isNewTask=false;"
    (save)="afterTaskAdded()">
</app-task-add>

<!--open task dialog, adjusting width to get toolbar in notes on one line -->
<div class="k-overlay" *ngIf="taskOpened"></div>
<kendo-window id="task-detail" [width]="1300" [height]="590" *ngIf="taskOpened" (close)="closeTaskDialog()"
    style="position:fixed" [top]="60" [state]="windowState">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 class="ellipsis-text">{{selectedTask.name}}</h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <button kendoWindowRestoreAction></button>
        <button *ngIf="!disableClose" kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <app-task-detail [task]="selectedTask" [autoComplete]="autoComplete" (completed)="onTaskCompleted()"
        (closeTaskDetail)="closeTaskDetail()" (followUpTaskAddedEvent)="getCaseDetailsData()" [isDialog]="true">
    </app-task-detail>
    <kendo-dialog-actions style="position:absolute;margin-left:-16px" class="w-100 mt-3">
        <button [disabled]="disableClose" kendoButton [primary]="true" type="button" (click)="closeTaskDialog()">
            {{ 'CLOSE' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-window>